export default "__VITE_ASSET__1eab99a7__"